import React, { useEffect, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { ApplicationContents } from "../application-contents";

export const IntroduceBlock = (props) => {
  const { title, subtitle = null, keyId, children } = props;
  return (
    <div className="introduce-block" id={keyId}>
      <h3 className="title">{title}</h3>
      {subtitle && <div className="subtitle">{subtitle}</div>}
      {children}
    </div>
  );
};

export const ApplicationList = () => {
  const { t } = useTranslation();
  const defaultNavList = [
    { key: "intro", label: t("application.contents.item1") },
    { key: "platform", label: t("application.contents.item2") },
    { key: "step", label: t("application.contents.item3") },
    { key: "integrate", label: t("application.contents.item4") },
  ];
  const platformCard = [
    {
      icon: "//files.authing.co/authing-website/marketplace-icon-one.png",
      title: t("application.application-list.item2.card1.title"),
      descript: t("application.application-list.item2.card1.descript"),
    },
    {
      icon: "//files.authing.co/authing-website/marketplace-icon-two.png",
      title: t("application.application-list.item2.card2.title"),
      descript: t("application.application-list.item2.card2.descript"),
    },
    {
      icon: "//files.authing.co/authing-website/marketplace-icon-three.png",
      title: t("application.application-list.item2.card3.title"),
      descript: t("application.application-list.item2.card3.descript"),
    },
  ];
  const integrateApp = [
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-huawei.png",
      link: "",
    },
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-aliyun.png",
      link: "",
    },
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-tecent.png",
      link: "",
    },
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-aws.png",
      link: "",
    },
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-serviceDesk.png",
      link: "",
    },
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-tecent-email.png",
      link: "",
    },
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-feishu.png",
      link: "",
    },
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-gitlab.png",
      link: "",
    },
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-zabbix.png",
      link: "",
    },
    {
      imgUrl: "//files.authing.co/authing-website/marketplace-etc.png",
      link: "",
    },
  ];
  const [listHeight, setListHeight] = useState(4856);
  const [navigation, setNavigation] = useState(true);
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.onload = () => {
        setListHeight(getElementHeight());
      };
      setNavigation(document.documentElement.clientWidth > 768);
      window.onresize = () => {
        setListHeight(getElementHeight());
        setNavigation(document.documentElement.clientWidth > 768);
      };
    }
  }, [defaultNavList]);
  const getElementHeight = () => {
    if (typeof window !== "undefined") {
      return Number(
        window
          .getComputedStyle(document.querySelector(".application-list"))
          .height.split("px")[0]
      );
    }
  };
  return (
    <div className="application-list">
      <div className="inner">
        {navigation && (
          <ApplicationContents
            navList={defaultNavList}
            listHeight={listHeight}
          />
        )}
        <div className="content-list-warp">
          <IntroduceBlock
            title={t("application.application-list.item1.title")}
            keyId="intro"
          >
            <div className="descript">
              {t("application.application-list.item1.descript1")}
            </div>
            <div className="descript">
              {t("application.application-list.item1.descript2")}
            </div>
            <div className="imgUrl">
              <img
                src="//files.authing.co/authing-website/application-block-intro.png"
                alt="authing"
              />
            </div>
          </IntroduceBlock>
          <IntroduceBlock
            title={t("application.application-list.item2.title")}
            subtitle={t("application.application-list.item2.subtitle")}
            keyId="platform"
          >
            <div className="card-warp">
              {platformCard.map((card) => (
                <div className="intro-card">
                  <div className="icon">
                    <img src={card.icon} alt="authing" />
                  </div>
                  <div className="title">{card.title}</div>
                  <div className="descript">{card.descript}</div>
                </div>
              ))}
            </div>
          </IntroduceBlock>
          <IntroduceBlock
            title={t("application.application-list.item3.title")}
            keyId="step"
          >
            <div className="descript">
              {t("application.application-list.item3.descript1")}
            </div>
            <div className="descript">
              {t("application.application-list.item3.descript2")}
            </div>
            <div className="descript-img">
              <img
                src="//files.authing.co/authing-website/marketplace-step-1.png"
                alt=""
              />
            </div>
            <div className="descript">
              {t("application.application-list.item3.descript3")}
            </div>
            <div className="descript">
              {t("application.application-list.item3.descript4")}
            </div>
            <div className="descript-list">
              {t("application.application-list.item3.descript4-list1")}
            </div>
            <div className="descript-list">
              {t("application.application-list.item3.descript4-list2")}
            </div>
            <div className="descript-list">
              {t("application.application-list.item3.descript4-list3")}
            </div>
            <div className="descript-img">
              <img
                src="//files.authing.co/authing-website/marketplace-step-2.png"
                alt=""
              />
            </div>
            <div className="descript">
              {t("application.application-list.item3.descript5")}
            </div>
            <div className="descript-img">
              <img
                src="//files.authing.co/authing-website/marketplace-step-3.png"
                alt=""
              />
            </div>
            <div className="descript">
              {t("application.application-list.item3.descript6")}
            </div>
            <div className="descript-img">
              <img
                src="//files.authing.co/authing-website/marketplace-step-4.png"
                alt=""
              />
            </div>
            <div className="descript">
              {t("application.application-list.item3.descript7")}
            </div>
            <div className="descript-img">
              <img
                src="//files.authing.co/authing-website/marketplace-step-5.png"
                alt=""
              />
            </div>
            <div className="descript">
              {t("application.application-list.item3.descript8")}
            </div>
            <div className="descript-list font-bold">
              {t("application.application-list.item3.descript8-list1")}
            </div>
            <div className="descript-list font-bold">
              {t("application.application-list.item3.descript8-list2")}
            </div>
            <div className="descript-list font-bold">
              {t("application.application-list.item3.descript8-list3")}
            </div>
          </IntroduceBlock>
          <IntroduceBlock
            title={t("application.application-list.item4.title")}
            keyId="integrate"
          >
            <div className="integrate-app-warp">
              {integrateApp.map((app) => (
                <div className="app-img">
                  <img src={app.imgUrl} alt="" />
                </div>
              ))}
            </div>
          </IntroduceBlock>
        </div>
      </div>
    </div>
  );
};
